import React, { useCallback, useMemo, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getAxios, patchAxios } from "../Services/commonService";
import {
  API_DOLLAR_RATE_LIST,
  API_DOLLAR_RATE_UPDATE,
} from "../utils/api/ApiConstant";
import { DataTable, DisplayOrder, SubHeading } from "../Components";

const DollerRate = () => {
  const queryClient = useQueryClient();

  const { isLoading, data: dollarRateData } = useQuery({
    queryKey: ["dollarRateData"],
    queryFn: async () =>
      await getAxios({
        url: API_DOLLAR_RATE_LIST,
        payload: {},
      }),
  });

  const handleQueryClient = (rowData, updatedRowData, key) => {
    return queryClient.setQueryData(["dollarRateData"], (oldData) => {
      if (!oldData) return oldData;

      return oldData.map((obj) =>
        obj.apiUrl === rowData.apiUrl
          ? { ...obj, [key]: updatedRowData[key] }
          : obj
      );
    });
  };

  const handleUpdateRequest = async ({ url, rowData, newValue, key }) => {
    if (rowData && rowData?._id) {
      const payload = { ...rowData, [key]: newValue };
      const costumUrl = `${url}/${rowData?._id}`;

      const res = await patchAxios({ url: costumUrl, payload });

      if (res) {
        handleQueryClient(rowData, payload, key);
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "settingName",
        header: "Setting Name",
        cell: ({ row }) => "Dollar",
      },
      {
        accessorKey: "remark",
        header: "Remark",
        cell: ({ row }) => "Dollar",
      },
      {
        accessorKey: "dollerRate",
        header: "Default Value",
        cell: ({ row }) => {
          return (
            <DisplayOrder
              initialValue={row?.original?.dollerRate}
              onConfirm={(newValue) =>
                handleUpdateRequest({
                  url: API_DOLLAR_RATE_UPDATE,
                  rowData: row?.original,
                  newValue,
                  key: "dollerRate",
                })
              }
            />
          );
        },
      },
    ],
    []
  );

  const fetchData = useCallback(() => {
    if (!dollarRateData) return { data: [], pages: 0 };

    return {
      data: dollarRateData,
      pages: dollarRateData?.totalPages,
    };
  }, [dollarRateData]);

  return (
    <>
      <SubHeading subTitle="Badla Setting" isAddBtn={false} />

      <div className="card-body">
        <DataTable
          columns={columns}
          fetchData={fetchData}
          isLoading={isLoading}
          isIndexing={true}
          isCheckBox={false}
          isPageSize={false}
          isSearchable={false}
          isPagination={false}
        />
      </div>
    </>
  );
};

export default DollerRate;
